/* -------------------------------------------------------------------------- */
/*                                Tab styles                               */
/* -------------------------------------------------------------------------- */

@import './bq-tab.variables';

:host {
  @apply inline-block;
}

.bq-tab {
  @apply relative flex cursor-pointer items-center justify-center rounded-s disabled:cursor-not-allowed disabled:opacity-60;
  @apply text-[length:--bq-tab--font-size] font-[--bq-tab--font-weight] leading-[--bq-tab--line-height] [&:not([disabled])]:hover:bg-hover-ui-primary [&:not([disabled])]:hover:text-hover-brand;
  @apply border-0 bg-transparent focus-visible:focus;
  @apply transition-[color,background-color,border-color,box-shadow] duration-300;

  &::after {
    @apply absolute z-[1] block bg-brand opacity-0 content-empty -inset-be-1;
    @apply transition-opacity duration-300 ease-linear;
  }

  &--horizontal-start,
  &--horizontal-end {
    &::after {
      /**
     * This hack will make the underline larger so it fits till the tab bar edges for the first and last tab button,
     * because the parent container applies some padding to not cut the focus outline style.
     */
      @apply -start-xs3 bs-[2px] is-[calc(100%_+_var(--bq-spacing-xs2))];
    }
  }

  &--vertical-start {
    @apply justify-end is-full;

    &::after {
      @apply -end-xs2 bs-[calc(100%_+_var(--bq-spacing-xs2))] is-[2px];
    }
  }

  &--vertical-end {
    @apply justify-start is-full;

    &::after {
      @apply -start-xs2 bs-[calc(100%_+_var(--bq-spacing-xs2))] is-[2px];
    }
  }

  &[aria-selected='true']::after {
    @apply opacity-100;
  }

  &--small {
    @apply p-b-[--bq-tab--padding-vertical-small] p-i-[--bq-tab--padding-horizontal-small];

    ::slotted(bq-icon) {
      --bq-icon--size: var(--bq-tab--icon-size-small) #{!important};
    }
  }

  &--medium {
    @apply p-b-[--bq-tab--padding-vertical-medium] p-i-[--bq-tab--padding-horizontal-medium];

    ::slotted(bq-icon) {
      --bq-icon--size: var(--bq-tab--icon-size-medium) #{!important};
    }
  }

  &--large {
    @apply text-l p-b-[--bq-tab--padding-vertical-large] p-i-[--bq-tab--padding-horizontal-large];

    ::slotted(bq-icon) {
      --bq-icon--size: var(--bq-tab--icon-size-large) #{!important};
    }
  }
}
